export default __webpack_public_path__ + "static/media/19.c3394441.jpeg";